// extracted by mini-css-extract-plugin
export default {"Locations":"Locations_Locations__VUFJd"};